import React, { useState } from "react";
import {
  Box,
  Input,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  Heading,
  Text,
  VStack,
  Card,
  CardBody,
} from "@chakra-ui/react";

const diseaseData = {
  cattle: [
    {
      id: "D001",
      name: "โรคปากและเท้าเปื่อย",
      symptoms: "มีไข้, เป็นแผลที่ปากและกีบ",
      prevention: "ฉีดวัคซีนป้องกันปีละ 2 ครั้ง",
      treatment: "ให้ยาลดไข้และยาปฏิชีวนะ",
    },
    {
      id: "D002",
      name: "โรคเฮโมรายิกเซพติกซีเมีย",
      symptoms: "ซึม, ไอ, หายใจลำบาก",
      prevention: "ฉีดวัคซีนป้องกันปีละครั้ง",
      treatment: "ใช้ยาปฏิชีวนะและแยกสัตว์ป่วย",
    },
  ],
  pig: [
    {
      id: "D003",
      name: "อหิวาต์สุกร",
      symptoms: "ท้องเสียรุนแรง, ซึม, เบื่ออาหาร",
      prevention: "ฉีดวัคซีนป้องกันทุก 6 เดือน",
      treatment: "ให้ยาลดอาการท้องเสียและแยกสุกรป่วย",
    },
    {
      id: "D004",
      name: "โรคปากเท้าเปื่อย (FMD)",
      symptoms: "แผลที่ปากและกีบ, น้ำลายไหล",
      prevention: "ฉีดวัคซีนทุก 4 เดือน",
      treatment: "ให้ยาลดไข้และดูแลแผล",
    },
  ],
  poultry: [
    {
      id: "D005",
      name: "โรคหลอดลมอักเสบติดต่อ",
      symptoms: "หายใจลำบาก, ไอ, จาม",
      prevention: "ให้วัคซีนและแยกสัตว์ป่วย",
      treatment: "ให้ยาปฏิชีวนะและวิตามินเสริม",
    },
    {
      id: "D006",
      name: "โรคไข้หวัดนก",
      symptoms: "ซึม, หายใจลำบาก, ท้องเสีย",
      prevention: "ควบคุมการเลี้ยงและฉีดวัคซีน",
      treatment: "แยกสัตว์ป่วยและทำลายเชื้อ",
    },
  ],
};

const highlights = [
  { title: "การป้องกันโรค", description: "การฉีดวัคซีนและจัดการสุขอนามัยช่วยลดการแพร่ระบาดของโรค" },
  { title: "การตรวจสอบสุขภาพสัตว์", description: "หมั่นสังเกตอาการป่วยของสัตว์เพื่อรับการรักษาอย่างทันท่วงที" },
  { title: "การแยกสัตว์ป่วย", description: "หากพบสัตว์ป่วย ควรแยกออกจากฝูงเพื่อลดการแพร่กระจายของโรค" },
];

const DiseaseInfo = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filterDiseases = (category) => {
    return diseaseData[category].filter((disease) =>
      disease.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
    <Box p={6} maxW="1200px" mx="auto">
      {/* Header */}
      <Heading mb={4} textAlign="center">
        ข้อมูลโรคในสัตว์
      </Heading>

      {/* Search Box */}
      <Input
        placeholder="ค้นหาโรค..."
        mb={6}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {/* Highlights */}
      <Grid templateColumns="repeat(3, 1fr)" gap={6} mb={6}>
        {highlights.map((highlight, index) => (
          <Card key={index} borderRadius="lg" p={4} boxShadow="md">
            <CardBody>
              <Heading size="md" mb={2}>
                {highlight.title}
              </Heading>
              <Text>{highlight.description}</Text>
            </CardBody>
          </Card>
        ))}
      </Grid>

      {/* Disease List Tabs */}
      <Tabs variant="enclosed">
        <TabList>
          <Tab>โรคในโค-กระบือ</Tab>
          <Tab>โรคในสุกร</Tab>
          <Tab>โรคในสัตว์ปีก</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <VStack align="stretch" spacing={4}>
              {filterDiseases("cattle").map((disease) => (
                <Box key={disease.id} p={4} borderWidth="1px" borderRadius="lg">
                  <Heading size="md">{disease.name}</Heading>
                  <Text>อาการ: {disease.symptoms}</Text>
                  <Text>การป้องกัน: {disease.prevention}</Text>
                  <Text>การรักษา: {disease.treatment}</Text>
                </Box>
              ))}
            </VStack>
          </TabPanel>

          <TabPanel>
            <VStack align="stretch" spacing={4}>
              {filterDiseases("pig").map((disease) => (
                <Box key={disease.id} p={4} borderWidth="1px" borderRadius="lg">
                  <Heading size="md">{disease.name}</Heading>
                  <Text>อาการ: {disease.symptoms}</Text>
                  <Text>การป้องกัน: {disease.prevention}</Text>
                  <Text>การรักษา: {disease.treatment}</Text>
                </Box>
              ))}
            </VStack>
          </TabPanel>

          <TabPanel>
            <VStack align="stretch" spacing={4}>
              {filterDiseases("poultry").map((disease) => (
                <Box key={disease.id} p={4} borderWidth="1px" borderRadius="lg">
                  <Heading size="md">{disease.name}</Heading>
                  <Text>อาการ: {disease.symptoms}</Text>
                  <Text>การป้องกัน: {disease.prevention}</Text>
                  <Text>การรักษา: {disease.treatment}</Text>
                </Box>
              ))}
            </VStack>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default DiseaseInfo;
